import { MARKETING_PATHS } from "./components-v2/marketing/config";
import { isComparePath } from "./components-v2/marketing/compare/comparePages";

export const APP_SURFACES = {
  MARKETING: "marketing",
  V1: "v1",
  V2: "v2"
};

// Hard domain boundary for the marketing surface. Tenant Platforms live on their own domains
// and any of them could end up with dashboardOnly=false, so the flag alone must never be
// enough — only Tribe's own marketing domain (or a local/preview review host) may render it.
const MARKETING_HOSTNAMES = new Set([
  "tribe.social",
  "www.tribe.social",
  "tribesocial.io",
  "www.tribesocial.io"
]);
const LOCAL_REVIEW_HOSTNAMES = new Set([
  "localhost",
  "127.0.0.1",
  "[::1]",
  "::1",
  "preview.tribesocial.io"
]);

const MARKETING_PATHNAMES = new Set(Object.values(MARKETING_PATHS));

export function isMarketingHostname(hostname) {
  const normalized = (hostname || "").toLowerCase();
  if (MARKETING_HOSTNAMES.has(normalized)) return true;
  if (LOCAL_REVIEW_HOSTNAMES.has(normalized)) return true;
  return normalized.startsWith("192.168.");
}

function canonicalizePathname(pathname = "") {
  if (pathname.length > 1 && pathname.endsWith("/")) return pathname.slice(0, -1);
  return pathname || "/";
}

export function isMarketingPath(pathname = "") {
  const canonical = canonicalizePathname(pathname);
  return MARKETING_PATHNAMES.has(canonical) || isComparePath(canonical);
}

export function getAppSurface(
  platformData,
  pathname,
  allowMarketingSurface = false,
  hostname = ""
) {
  if (!platformData?.version) return null;

  // Marketing needs all three independent layers: an authorized hostname, dashboardOnly=false,
  // and the v2 platform version — a legacy v1 tenant can never render it, even if its flags drift.
  if (
    allowMarketingSurface &&
    isMarketingHostname(hostname) &&
    platformData.version === "v2" &&
    platformData.dashboardOnly === false &&
    isMarketingPath(pathname)
  ) {
    return APP_SURFACES.MARKETING;
  }

  return platformData.version === "v1" ? APP_SURFACES.V1 : APP_SURFACES.V2;
}

export function hasWebHomePage(platformData) {
  return platformData?.version === "v1" && !platformData?.dashboardOnly;
}
